/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($userId: Int) {
    getUser(userId: $userId) {
      userId
      emailAddress
      username
      firstName
      lastName
      __typename
    }
  }
`;
export const getLoggedInUser = /* GraphQL */ `
  query GetLoggedInUser {
    getLoggedInUser {
      userId
      emailAddress
      username
      firstName
      lastName
      __typename
    }
  }
`;
export const getIsUserAdmin = /* GraphQL */ `
  query GetIsUserAdmin {
    getIsUserAdmin
  }
`;
export const getUserClasses = /* GraphQL */ `
  query GetUserClasses {
    getUserClasses {
      libraryAccess
      classesTaking {
        id
        title
        urlKey
        type
        curriculumType
        image {
          path
          crops {
            path
            dimensions
            width
            height
            __typename
          }
          __typename
        }
        instructors {
          id
          image
          biography
          name {
            honorific
            first
            last
            suffix
            nickname
            credentials
            fullName
            __typename
          }
          __typename
        }
        instructorDisplay
        teachingAssistants {
          id
          image
          biography
          name {
            honorific
            first
            last
            suffix
            nickname
            credentials
            fullName
            __typename
          }
          __typename
        }
        resources {
          id
          type
          title
          url
          termId
          featureOnDashboard
          __typename
        }
        modules {
          id
          title
          description
          currentModule
          image
          active
          lessons {
            id
            classId
            moduleId
            termId
            title
            active
            currentLesson
            image
            description
            type
            instructorIds
            resources {
              id
              type
              title
              url
              termId
              featureOnDashboard
              __typename
            }
            videoId
            videoDurationInSec
            videoUrl
            mediaUrl
            videoPlayerHead
            completed
            required
            assignmentQuestions {
              id
              questionText
              questionChoices {
                id
                text
                __typename
              }
              answerId
              __typename
            }
            assessmentQuestions {
              id
              questionText
              questionChoices {
                id
                text
                __typename
              }
              answerId
              randomize
              __typename
            }
            instances {
              id
              link
              host
              startDate
              videoId
              mediaUrl
              trackReplayAttendance
              __typename
            }
            quizInProgress
            __typename
          }
          modules {
            id
            title
            description
            currentModule
            image
            active
            lessons {
              id
              classId
              moduleId
              termId
              title
              active
              currentLesson
              image
              description
              type
              instructorIds
              resources {
                id
                type
                title
                url
                termId
                featureOnDashboard
                __typename
              }
              videoId
              videoDurationInSec
              videoUrl
              mediaUrl
              videoPlayerHead
              completed
              required
              assignmentQuestions {
                id
                questionText
                answerId
                __typename
              }
              assessmentQuestions {
                id
                questionText
                answerId
                randomize
                __typename
              }
              instances {
                id
                link
                host
                startDate
                videoId
                mediaUrl
                trackReplayAttendance
                __typename
              }
              quizInProgress
              __typename
            }
            modules {
              id
              title
              description
              currentModule
              image
              active
              lessons {
                id
                classId
                moduleId
                termId
                title
                active
                currentLesson
                image
                description
                type
                instructorIds
                videoId
                videoDurationInSec
                videoUrl
                mediaUrl
                videoPlayerHead
                completed
                required
                quizInProgress
                __typename
              }
              modules {
                id
                title
                description
                currentModule
                image
                active
                type
                upcoming
                __typename
              }
              type
              upcoming
              __typename
            }
            type
            upcoming
            __typename
          }
          type
          upcoming
          __typename
        }
        favoriteLessons {
          id
          classId
          moduleId
          termId
          title
          active
          currentLesson
          image
          description
          type
          instructorIds
          resources {
            id
            type
            title
            url
            termId
            featureOnDashboard
            __typename
          }
          videoId
          videoDurationInSec
          videoUrl
          mediaUrl
          videoPlayerHead
          completed
          required
          assignmentQuestions {
            id
            questionText
            questionChoices {
              id
              text
              __typename
            }
            answerId
            __typename
          }
          assessmentQuestions {
            id
            questionText
            questionChoices {
              id
              text
              __typename
            }
            answerId
            randomize
            __typename
          }
          instances {
            id
            link
            host
            startDate
            videoId
            mediaUrl
            trackReplayAttendance
            __typename
          }
          quizInProgress
          __typename
        }
        term {
          id
          title
          startDate
          signupCutOffDate
          __typename
        }
        terms {
          id
          title
          startDate
          signupCutOffDate
          __typename
        }
        price
        totalProgress
        demoCloudinaryImage {
          path
          crops {
            path
            dimensions
            width
            height
            __typename
          }
          __typename
        }
        curriculum
        categories
        userType
        freeTrialInfo {
          token
          activated
          totalSecondsConsumed
          freeTrialLimit
          __typename
        }
        notifications {
          unread {
            id
            type
            url
            qnaTitle
            classTitle
            classId
            text
            subText
            createDate
            qnaStartDate
            classCategory
            classUrlKey
            __typename
          }
          read {
            id
            type
            url
            qnaTitle
            classTitle
            classId
            text
            subText
            createDate
            qnaStartDate
            classCategory
            classUrlKey
            __typename
          }
          __typename
        }
        description
        classMaterials
        classStarted
        videoAssignments {
          id
          maxLengthInSeconds
          objectType
          minLengthInSeconds
          gsi_pk
          active
          termId
          sk
          pk
          gradingNeeded
          submissionDueDate
          title
          __typename
        }
        disableFirstModule
        hidePsa
        __typename
      }
      favoriteLessons {
        id
        classId
        moduleId
        termId
        title
        active
        currentLesson
        image
        description
        type
        instructorIds
        resources {
          id
          type
          title
          url
          termId
          featureOnDashboard
          __typename
        }
        videoId
        videoDurationInSec
        videoUrl
        mediaUrl
        videoPlayerHead
        completed
        required
        assignmentQuestions {
          id
          questionText
          questionChoices {
            id
            text
            __typename
          }
          answerId
          __typename
        }
        assessmentQuestions {
          id
          questionText
          questionChoices {
            id
            text
            __typename
          }
          answerId
          randomize
          __typename
        }
        instances {
          id
          link
          host
          startDate
          videoId
          mediaUrl
          trackReplayAttendance
          __typename
        }
        quizInProgress
        __typename
      }
      notifications {
        unread {
          id
          type
          url
          qnaTitle
          classTitle
          classId
          text
          subText
          createDate
          qnaStartDate
          classCategory
          classUrlKey
          __typename
        }
        read {
          id
          type
          url
          qnaTitle
          classTitle
          classId
          text
          subText
          createDate
          qnaStartDate
          classCategory
          classUrlKey
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getClassesTeaching = /* GraphQL */ `
  query GetClassesTeaching {
    getClassesTeaching {
      classesTeaching {
        id
        title
        urlKey
        type
        image {
          path
          crops {
            path
            dimensions
            width
            height
            __typename
          }
          __typename
        }
        publishDate
        userType
        unreadAssignmentsCount
        __typename
      }
      favoriteLessons {
        id
        classId
        moduleId
        termId
        title
        active
        currentLesson
        image
        description
        type
        instructorIds
        resources {
          id
          type
          title
          url
          termId
          featureOnDashboard
          __typename
        }
        videoId
        videoDurationInSec
        videoUrl
        mediaUrl
        videoPlayerHead
        completed
        required
        assignmentQuestions {
          id
          questionText
          questionChoices {
            id
            text
            __typename
          }
          answerId
          __typename
        }
        assessmentQuestions {
          id
          questionText
          questionChoices {
            id
            text
            __typename
          }
          answerId
          randomize
          __typename
        }
        instances {
          id
          link
          host
          startDate
          videoId
          mediaUrl
          trackReplayAttendance
          __typename
        }
        quizInProgress
        __typename
      }
      __typename
    }
  }
`;
export const getUserAccessibleClasses = /* GraphQL */ `
  query GetUserAccessibleClasses {
    getUserAccessibleClasses {
      id
      title
      urlKey
      type
      curriculumType
      image {
        path
        crops {
          path
          dimensions
          width
          height
          __typename
        }
        __typename
      }
      instructors {
        id
        image
        biography
        name {
          honorific
          first
          last
          suffix
          nickname
          credentials
          fullName
          __typename
        }
        __typename
      }
      instructorDisplay
      teachingAssistants {
        id
        image
        biography
        name {
          honorific
          first
          last
          suffix
          nickname
          credentials
          fullName
          __typename
        }
        __typename
      }
      resources {
        id
        type
        title
        url
        termId
        featureOnDashboard
        __typename
      }
      modules {
        id
        title
        description
        currentModule
        image
        active
        lessons {
          id
          classId
          moduleId
          termId
          title
          active
          currentLesson
          image
          description
          type
          instructorIds
          resources {
            id
            type
            title
            url
            termId
            featureOnDashboard
            __typename
          }
          videoId
          videoDurationInSec
          videoUrl
          mediaUrl
          videoPlayerHead
          completed
          required
          assignmentQuestions {
            id
            questionText
            questionChoices {
              id
              text
              __typename
            }
            answerId
            __typename
          }
          assessmentQuestions {
            id
            questionText
            questionChoices {
              id
              text
              __typename
            }
            answerId
            randomize
            __typename
          }
          instances {
            id
            link
            host
            startDate
            videoId
            mediaUrl
            trackReplayAttendance
            __typename
          }
          quizInProgress
          __typename
        }
        modules {
          id
          title
          description
          currentModule
          image
          active
          lessons {
            id
            classId
            moduleId
            termId
            title
            active
            currentLesson
            image
            description
            type
            instructorIds
            resources {
              id
              type
              title
              url
              termId
              featureOnDashboard
              __typename
            }
            videoId
            videoDurationInSec
            videoUrl
            mediaUrl
            videoPlayerHead
            completed
            required
            assignmentQuestions {
              id
              questionText
              questionChoices {
                id
                text
                __typename
              }
              answerId
              __typename
            }
            assessmentQuestions {
              id
              questionText
              questionChoices {
                id
                text
                __typename
              }
              answerId
              randomize
              __typename
            }
            instances {
              id
              link
              host
              startDate
              videoId
              mediaUrl
              trackReplayAttendance
              __typename
            }
            quizInProgress
            __typename
          }
          modules {
            id
            title
            description
            currentModule
            image
            active
            lessons {
              id
              classId
              moduleId
              termId
              title
              active
              currentLesson
              image
              description
              type
              instructorIds
              resources {
                id
                type
                title
                url
                termId
                featureOnDashboard
                __typename
              }
              videoId
              videoDurationInSec
              videoUrl
              mediaUrl
              videoPlayerHead
              completed
              required
              assignmentQuestions {
                id
                questionText
                answerId
                __typename
              }
              assessmentQuestions {
                id
                questionText
                answerId
                randomize
                __typename
              }
              instances {
                id
                link
                host
                startDate
                videoId
                mediaUrl
                trackReplayAttendance
                __typename
              }
              quizInProgress
              __typename
            }
            modules {
              id
              title
              description
              currentModule
              image
              active
              lessons {
                id
                classId
                moduleId
                termId
                title
                active
                currentLesson
                image
                description
                type
                instructorIds
                videoId
                videoDurationInSec
                videoUrl
                mediaUrl
                videoPlayerHead
                completed
                required
                quizInProgress
                __typename
              }
              modules {
                id
                title
                description
                currentModule
                image
                active
                type
                upcoming
                __typename
              }
              type
              upcoming
              __typename
            }
            type
            upcoming
            __typename
          }
          type
          upcoming
          __typename
        }
        type
        upcoming
        __typename
      }
      favoriteLessons {
        id
        classId
        moduleId
        termId
        title
        active
        currentLesson
        image
        description
        type
        instructorIds
        resources {
          id
          type
          title
          url
          termId
          featureOnDashboard
          __typename
        }
        videoId
        videoDurationInSec
        videoUrl
        mediaUrl
        videoPlayerHead
        completed
        required
        assignmentQuestions {
          id
          questionText
          questionChoices {
            id
            text
            __typename
          }
          answerId
          __typename
        }
        assessmentQuestions {
          id
          questionText
          questionChoices {
            id
            text
            __typename
          }
          answerId
          randomize
          __typename
        }
        instances {
          id
          link
          host
          startDate
          videoId
          mediaUrl
          trackReplayAttendance
          __typename
        }
        quizInProgress
        __typename
      }
      term {
        id
        title
        startDate
        signupCutOffDate
        __typename
      }
      terms {
        id
        title
        startDate
        signupCutOffDate
        __typename
      }
      price
      totalProgress
      demoCloudinaryImage {
        path
        crops {
          path
          dimensions
          width
          height
          __typename
        }
        __typename
      }
      curriculum
      categories
      userType
      freeTrialInfo {
        token
        activated
        totalSecondsConsumed
        freeTrialLimit
        __typename
      }
      notifications {
        unread {
          id
          type
          url
          qnaTitle
          classTitle
          classId
          text
          subText
          createDate
          qnaStartDate
          classCategory
          classUrlKey
          __typename
        }
        read {
          id
          type
          url
          qnaTitle
          classTitle
          classId
          text
          subText
          createDate
          qnaStartDate
          classCategory
          classUrlKey
          __typename
        }
        __typename
      }
      description
      classMaterials
      classStarted
      videoAssignments {
        id
        maxLengthInSeconds
        objectType
        minLengthInSeconds
        gsi_pk
        active
        termId
        sk
        pk
        gradingNeeded
        submissionDueDate
        title
        __typename
      }
      disableFirstModule
      hidePsa
      __typename
    }
  }
`;
export const getUserInaccessibleClasses = /* GraphQL */ `
  query GetUserInaccessibleClasses {
    getUserInaccessibleClasses {
      id
      title
      urlKey
      type
      curriculumType
      image {
        path
        crops {
          path
          dimensions
          width
          height
          __typename
        }
        __typename
      }
      instructors {
        id
        image
        biography
        name {
          honorific
          first
          last
          suffix
          nickname
          credentials
          fullName
          __typename
        }
        __typename
      }
      instructorDisplay
      teachingAssistants {
        id
        image
        biography
        name {
          honorific
          first
          last
          suffix
          nickname
          credentials
          fullName
          __typename
        }
        __typename
      }
      resources {
        id
        type
        title
        url
        termId
        featureOnDashboard
        __typename
      }
      modules {
        id
        title
        description
        currentModule
        image
        active
        lessons {
          id
          classId
          moduleId
          termId
          title
          active
          currentLesson
          image
          description
          type
          instructorIds
          resources {
            id
            type
            title
            url
            termId
            featureOnDashboard
            __typename
          }
          videoId
          videoDurationInSec
          videoUrl
          mediaUrl
          videoPlayerHead
          completed
          required
          assignmentQuestions {
            id
            questionText
            questionChoices {
              id
              text
              __typename
            }
            answerId
            __typename
          }
          assessmentQuestions {
            id
            questionText
            questionChoices {
              id
              text
              __typename
            }
            answerId
            randomize
            __typename
          }
          instances {
            id
            link
            host
            startDate
            videoId
            mediaUrl
            trackReplayAttendance
            __typename
          }
          quizInProgress
          __typename
        }
        modules {
          id
          title
          description
          currentModule
          image
          active
          lessons {
            id
            classId
            moduleId
            termId
            title
            active
            currentLesson
            image
            description
            type
            instructorIds
            resources {
              id
              type
              title
              url
              termId
              featureOnDashboard
              __typename
            }
            videoId
            videoDurationInSec
            videoUrl
            mediaUrl
            videoPlayerHead
            completed
            required
            assignmentQuestions {
              id
              questionText
              questionChoices {
                id
                text
                __typename
              }
              answerId
              __typename
            }
            assessmentQuestions {
              id
              questionText
              questionChoices {
                id
                text
                __typename
              }
              answerId
              randomize
              __typename
            }
            instances {
              id
              link
              host
              startDate
              videoId
              mediaUrl
              trackReplayAttendance
              __typename
            }
            quizInProgress
            __typename
          }
          modules {
            id
            title
            description
            currentModule
            image
            active
            lessons {
              id
              classId
              moduleId
              termId
              title
              active
              currentLesson
              image
              description
              type
              instructorIds
              resources {
                id
                type
                title
                url
                termId
                featureOnDashboard
                __typename
              }
              videoId
              videoDurationInSec
              videoUrl
              mediaUrl
              videoPlayerHead
              completed
              required
              assignmentQuestions {
                id
                questionText
                answerId
                __typename
              }
              assessmentQuestions {
                id
                questionText
                answerId
                randomize
                __typename
              }
              instances {
                id
                link
                host
                startDate
                videoId
                mediaUrl
                trackReplayAttendance
                __typename
              }
              quizInProgress
              __typename
            }
            modules {
              id
              title
              description
              currentModule
              image
              active
              lessons {
                id
                classId
                moduleId
                termId
                title
                active
                currentLesson
                image
                description
                type
                instructorIds
                videoId
                videoDurationInSec
                videoUrl
                mediaUrl
                videoPlayerHead
                completed
                required
                quizInProgress
                __typename
              }
              modules {
                id
                title
                description
                currentModule
                image
                active
                type
                upcoming
                __typename
              }
              type
              upcoming
              __typename
            }
            type
            upcoming
            __typename
          }
          type
          upcoming
          __typename
        }
        type
        upcoming
        __typename
      }
      favoriteLessons {
        id
        classId
        moduleId
        termId
        title
        active
        currentLesson
        image
        description
        type
        instructorIds
        resources {
          id
          type
          title
          url
          termId
          featureOnDashboard
          __typename
        }
        videoId
        videoDurationInSec
        videoUrl
        mediaUrl
        videoPlayerHead
        completed
        required
        assignmentQuestions {
          id
          questionText
          questionChoices {
            id
            text
            __typename
          }
          answerId
          __typename
        }
        assessmentQuestions {
          id
          questionText
          questionChoices {
            id
            text
            __typename
          }
          answerId
          randomize
          __typename
        }
        instances {
          id
          link
          host
          startDate
          videoId
          mediaUrl
          trackReplayAttendance
          __typename
        }
        quizInProgress
        __typename
      }
      term {
        id
        title
        startDate
        signupCutOffDate
        __typename
      }
      terms {
        id
        title
        startDate
        signupCutOffDate
        __typename
      }
      price
      totalProgress
      demoCloudinaryImage {
        path
        crops {
          path
          dimensions
          width
          height
          __typename
        }
        __typename
      }
      curriculum
      categories
      userType
      freeTrialInfo {
        token
        activated
        totalSecondsConsumed
        freeTrialLimit
        __typename
      }
      notifications {
        unread {
          id
          type
          url
          qnaTitle
          classTitle
          classId
          text
          subText
          createDate
          qnaStartDate
          classCategory
          classUrlKey
          __typename
        }
        read {
          id
          type
          url
          qnaTitle
          classTitle
          classId
          text
          subText
          createDate
          qnaStartDate
          classCategory
          classUrlKey
          __typename
        }
        __typename
      }
      description
      classMaterials
      classStarted
      videoAssignments {
        id
        maxLengthInSeconds
        objectType
        minLengthInSeconds
        gsi_pk
        active
        termId
        sk
        pk
        gradingNeeded
        submissionDueDate
        title
        __typename
      }
      disableFirstModule
      hidePsa
      __typename
    }
  }
`;
export const getUserClass = /* GraphQL */ `
  query GetUserClass($classId: Int, $classSlug: String, $termId: Int) {
    getUserClass(classId: $classId, classSlug: $classSlug, termId: $termId) {
      id
      title
      urlKey
      type
      curriculumType
      image {
        path
        crops {
          path
          dimensions
          width
          height
          __typename
        }
        __typename
      }
      instructors {
        id
        image
        biography
        name {
          honorific
          first
          last
          suffix
          nickname
          credentials
          fullName
          __typename
        }
        __typename
      }
      instructorDisplay
      teachingAssistants {
        id
        image
        biography
        name {
          honorific
          first
          last
          suffix
          nickname
          credentials
          fullName
          __typename
        }
        __typename
      }
      resources {
        id
        type
        title
        url
        termId
        featureOnDashboard
        __typename
      }
      modules {
        id
        title
        description
        currentModule
        image
        active
        lessons {
          id
          classId
          moduleId
          termId
          title
          active
          currentLesson
          image
          description
          type
          instructorIds
          resources {
            id
            type
            title
            url
            termId
            featureOnDashboard
            __typename
          }
          videoId
          videoDurationInSec
          videoUrl
          mediaUrl
          videoPlayerHead
          completed
          required
          assignmentQuestions {
            id
            questionText
            questionChoices {
              id
              text
              __typename
            }
            answerId
            __typename
          }
          assessmentQuestions {
            id
            questionText
            questionChoices {
              id
              text
              __typename
            }
            answerId
            randomize
            __typename
          }
          instances {
            id
            link
            host
            startDate
            videoId
            mediaUrl
            trackReplayAttendance
            __typename
          }
          quizInProgress
          __typename
        }
        modules {
          id
          title
          description
          currentModule
          image
          active
          lessons {
            id
            classId
            moduleId
            termId
            title
            active
            currentLesson
            image
            description
            type
            instructorIds
            resources {
              id
              type
              title
              url
              termId
              featureOnDashboard
              __typename
            }
            videoId
            videoDurationInSec
            videoUrl
            mediaUrl
            videoPlayerHead
            completed
            required
            assignmentQuestions {
              id
              questionText
              questionChoices {
                id
                text
                __typename
              }
              answerId
              __typename
            }
            assessmentQuestions {
              id
              questionText
              questionChoices {
                id
                text
                __typename
              }
              answerId
              randomize
              __typename
            }
            instances {
              id
              link
              host
              startDate
              videoId
              mediaUrl
              trackReplayAttendance
              __typename
            }
            quizInProgress
            __typename
          }
          modules {
            id
            title
            description
            currentModule
            image
            active
            lessons {
              id
              classId
              moduleId
              termId
              title
              active
              currentLesson
              image
              description
              type
              instructorIds
              resources {
                id
                type
                title
                url
                termId
                featureOnDashboard
                __typename
              }
              videoId
              videoDurationInSec
              videoUrl
              mediaUrl
              videoPlayerHead
              completed
              required
              assignmentQuestions {
                id
                questionText
                answerId
                __typename
              }
              assessmentQuestions {
                id
                questionText
                answerId
                randomize
                __typename
              }
              instances {
                id
                link
                host
                startDate
                videoId
                mediaUrl
                trackReplayAttendance
                __typename
              }
              quizInProgress
              __typename
            }
            modules {
              id
              title
              description
              currentModule
              image
              active
              lessons {
                id
                classId
                moduleId
                termId
                title
                active
                currentLesson
                image
                description
                type
                instructorIds
                videoId
                videoDurationInSec
                videoUrl
                mediaUrl
                videoPlayerHead
                completed
                required
                quizInProgress
                __typename
              }
              modules {
                id
                title
                description
                currentModule
                image
                active
                type
                upcoming
                __typename
              }
              type
              upcoming
              __typename
            }
            type
            upcoming
            __typename
          }
          type
          upcoming
          __typename
        }
        type
        upcoming
        __typename
      }
      favoriteLessons {
        id
        classId
        moduleId
        termId
        title
        active
        currentLesson
        image
        description
        type
        instructorIds
        resources {
          id
          type
          title
          url
          termId
          featureOnDashboard
          __typename
        }
        videoId
        videoDurationInSec
        videoUrl
        mediaUrl
        videoPlayerHead
        completed
        required
        assignmentQuestions {
          id
          questionText
          questionChoices {
            id
            text
            __typename
          }
          answerId
          __typename
        }
        assessmentQuestions {
          id
          questionText
          questionChoices {
            id
            text
            __typename
          }
          answerId
          randomize
          __typename
        }
        instances {
          id
          link
          host
          startDate
          videoId
          mediaUrl
          trackReplayAttendance
          __typename
        }
        quizInProgress
        __typename
      }
      term {
        id
        title
        startDate
        signupCutOffDate
        __typename
      }
      terms {
        id
        title
        startDate
        signupCutOffDate
        __typename
      }
      price
      totalProgress
      demoCloudinaryImage {
        path
        crops {
          path
          dimensions
          width
          height
          __typename
        }
        __typename
      }
      curriculum
      categories
      userType
      freeTrialInfo {
        token
        activated
        totalSecondsConsumed
        freeTrialLimit
        __typename
      }
      notifications {
        unread {
          id
          type
          url
          qnaTitle
          classTitle
          classId
          text
          subText
          createDate
          qnaStartDate
          classCategory
          classUrlKey
          __typename
        }
        read {
          id
          type
          url
          qnaTitle
          classTitle
          classId
          text
          subText
          createDate
          qnaStartDate
          classCategory
          classUrlKey
          __typename
        }
        __typename
      }
      description
      classMaterials
      classStarted
      videoAssignments {
        id
        maxLengthInSeconds
        objectType
        minLengthInSeconds
        gsi_pk
        active
        termId
        sk
        pk
        gradingNeeded
        submissionDueDate
        title
        __typename
      }
      disableFirstModule
      hidePsa
      __typename
    }
  }
`;
export const getClassSubscriptions = /* GraphQL */ `
  query GetClassSubscriptions(
    $classId: Int
    $libraryId: String
    $type: String
    $status: ClassSubscriptionStatus
    $previewToken: String
  ) {
    getClassSubscriptions(
      classId: $classId
      libraryId: $libraryId
      type: $type
      status: $status
      previewToken: $previewToken
    ) {
      id
      createDate
      type
      status
      orderId
      classId
      libraryId
      termId
      previewToken
      previewActivationDate
      subscriptionStartDate
      subscriptionEndDate
      __typename
    }
  }
`;
export const getClass = /* GraphQL */ `
  query GetClass($id: Int, $slug: String, $includeDetails: Boolean) {
    getClass(id: $id, slug: $slug, includeDetails: $includeDetails) {
      id
      urlKey
      active
      training
      title
      totalDuration
      shortTitle
      instructorDisplay
      modules {
        id
        title
        active
        sessions {
          id
          title
          moduleId
          video {
            width
            height
            duration
            thumbnail
            mediaId
            title
            __typename
          }
          videoAssignmentUpload
          active
          image
          availableBeforeTerm
          description
          gradingNeeded
          type
          questions {
            id
            question
            choices {
              id
              choice
              answer
              __typename
            }
            __typename
          }
          __typename
        }
        modules {
          id
          title
          active
          sessions {
            id
            title
            moduleId
            video {
              width
              height
              duration
              thumbnail
              mediaId
              title
              __typename
            }
            videoAssignmentUpload
            active
            image
            availableBeforeTerm
            description
            gradingNeeded
            type
            questions {
              id
              question
              choices {
                id
                choice
                answer
                __typename
              }
              __typename
            }
            __typename
          }
          modules {
            id
            title
            active
            sessions {
              id
              title
              moduleId
              video {
                width
                height
                duration
                thumbnail
                mediaId
                title
                __typename
              }
              videoAssignmentUpload
              active
              image
              availableBeforeTerm
              description
              gradingNeeded
              type
              questions {
                id
                question
                __typename
              }
              __typename
            }
            modules {
              id
              title
              active
              sessions {
                id
                title
                moduleId
                videoAssignmentUpload
                active
                image
                availableBeforeTerm
                description
                gradingNeeded
                type
                __typename
              }
              modules {
                id
                title
                active
                type
                upcoming
                __typename
              }
              type
              upcoming
              __typename
            }
            type
            upcoming
            __typename
          }
          type
          upcoming
          __typename
        }
        type
        upcoming
        __typename
      }
      bundleIds
      assistantUserIds
      image {
        path
        crops {
          path
          dimensions
          width
          height
          __typename
        }
        __typename
      }
      categories
      availableForPurchase
      previewVideos {
        width
        height
        duration
        thumbnail
        mediaId
        title
        __typename
      }
      description
      relatedClasses
      tags
      instructors
      __typename
    }
  }
`;
export const getModules = /* GraphQL */ `
  query GetModules($moduleIds: [String]!) {
    getModules(moduleIds: $moduleIds) {
      id
      title
      active
      sessions {
        id
        title
        moduleId
        video {
          width
          height
          duration
          thumbnail
          mediaId
          title
          __typename
        }
        videoAssignmentUpload
        active
        image
        availableBeforeTerm
        description
        gradingNeeded
        type
        questions {
          id
          question
          choices {
            id
            choice
            answer
            __typename
          }
          __typename
        }
        __typename
      }
      modules {
        id
        title
        active
        sessions {
          id
          title
          moduleId
          video {
            width
            height
            duration
            thumbnail
            mediaId
            title
            __typename
          }
          videoAssignmentUpload
          active
          image
          availableBeforeTerm
          description
          gradingNeeded
          type
          questions {
            id
            question
            choices {
              id
              choice
              answer
              __typename
            }
            __typename
          }
          __typename
        }
        modules {
          id
          title
          active
          sessions {
            id
            title
            moduleId
            video {
              width
              height
              duration
              thumbnail
              mediaId
              title
              __typename
            }
            videoAssignmentUpload
            active
            image
            availableBeforeTerm
            description
            gradingNeeded
            type
            questions {
              id
              question
              choices {
                id
                choice
                answer
                __typename
              }
              __typename
            }
            __typename
          }
          modules {
            id
            title
            active
            sessions {
              id
              title
              moduleId
              video {
                width
                height
                duration
                thumbnail
                mediaId
                title
                __typename
              }
              videoAssignmentUpload
              active
              image
              availableBeforeTerm
              description
              gradingNeeded
              type
              questions {
                id
                question
                __typename
              }
              __typename
            }
            modules {
              id
              title
              active
              sessions {
                id
                title
                moduleId
                videoAssignmentUpload
                active
                image
                availableBeforeTerm
                description
                gradingNeeded
                type
                __typename
              }
              modules {
                id
                title
                active
                type
                upcoming
                __typename
              }
              type
              upcoming
              __typename
            }
            type
            upcoming
            __typename
          }
          type
          upcoming
          __typename
        }
        type
        upcoming
        __typename
      }
      type
      upcoming
      __typename
    }
  }
`;
export const getSessions = /* GraphQL */ `
  query GetSessions($sessionIds: [String]!) {
    getSessions(sessionIds: $sessionIds) {
      id
      title
      moduleId
      video {
        width
        height
        duration
        thumbnail
        mediaId
        title
        __typename
      }
      videoAssignmentUpload
      active
      image
      availableBeforeTerm
      description
      gradingNeeded
      type
      questions {
        id
        question
        choices {
          id
          choice
          answer
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getQuestions = /* GraphQL */ `
  query GetQuestions(
    $classId: Int!
    $moduleId: String
    $size: Int
    $cursor: String
    $sortBy: String
  ) {
    getQuestions(
      classId: $classId
      moduleId: $moduleId
      size: $size
      cursor: $cursor
      sortBy: $sortBy
    ) {
      questions {
        id
        title
        body
        username
        userimage
        createDate
        lastActivityDate
        type
        classId
        moduleId
        termId
        answeredByInstructor
        answeredByTA
        responses {
          id
          user {
            id
            emailAddress
            username
            userimage
            type
            __typename
          }
          answerer {
            id
            emailAddress
            username
            userimage
            type
            __typename
          }
          answer
          createDate
          classId
          likes
          __typename
        }
        __typename
      }
      paginationCursor {
        questionId
        hasAfter
        __typename
      }
      __typename
    }
  }
`;
export const getAnswers = /* GraphQL */ `
  query GetAnswers($classId: Int!, $questionId: String!) {
    getAnswers(classId: $classId, questionId: $questionId) {
      id
      user {
        id
        emailAddress
        username
        userimage
        type
        __typename
      }
      answerer {
        id
        emailAddress
        username
        userimage
        type
        __typename
      }
      answer
      createDate
      classId
      likes
      __typename
    }
  }
`;
export const getRecommendedClasses = /* GraphQL */ `
  query GetRecommendedClasses {
    getRecommendedClasses {
      id
      urlKey
      active
      training
      title
      totalDuration
      shortTitle
      instructorDisplay
      modules {
        id
        title
        active
        sessions {
          id
          title
          moduleId
          video {
            width
            height
            duration
            thumbnail
            mediaId
            title
            __typename
          }
          videoAssignmentUpload
          active
          image
          availableBeforeTerm
          description
          gradingNeeded
          type
          questions {
            id
            question
            choices {
              id
              choice
              answer
              __typename
            }
            __typename
          }
          __typename
        }
        modules {
          id
          title
          active
          sessions {
            id
            title
            moduleId
            video {
              width
              height
              duration
              thumbnail
              mediaId
              title
              __typename
            }
            videoAssignmentUpload
            active
            image
            availableBeforeTerm
            description
            gradingNeeded
            type
            questions {
              id
              question
              choices {
                id
                choice
                answer
                __typename
              }
              __typename
            }
            __typename
          }
          modules {
            id
            title
            active
            sessions {
              id
              title
              moduleId
              video {
                width
                height
                duration
                thumbnail
                mediaId
                title
                __typename
              }
              videoAssignmentUpload
              active
              image
              availableBeforeTerm
              description
              gradingNeeded
              type
              questions {
                id
                question
                __typename
              }
              __typename
            }
            modules {
              id
              title
              active
              sessions {
                id
                title
                moduleId
                videoAssignmentUpload
                active
                image
                availableBeforeTerm
                description
                gradingNeeded
                type
                __typename
              }
              modules {
                id
                title
                active
                type
                upcoming
                __typename
              }
              type
              upcoming
              __typename
            }
            type
            upcoming
            __typename
          }
          type
          upcoming
          __typename
        }
        type
        upcoming
        __typename
      }
      bundleIds
      assistantUserIds
      image {
        path
        crops {
          path
          dimensions
          width
          height
          __typename
        }
        __typename
      }
      categories
      availableForPurchase
      previewVideos {
        width
        height
        duration
        thumbnail
        mediaId
        title
        __typename
      }
      description
      relatedClasses
      tags
      instructors
      __typename
    }
  }
`;
export const getAssignments = /* GraphQL */ `
  query GetAssignments($classId: Int!, $termId: Int, $moduleId: String) {
    getAssignments(classId: $classId, termId: $termId, moduleId: $moduleId) {
      id
      createDate
      lastActivityDate
      questionId
      questionTitle
      response
      classId
      moduleId
      lessonId
      termId
      termTitle
      user {
        id
        emailAddress
        username
        userimage
        type
        __typename
      }
      feedback {
        assignmentId
        user {
          id
          emailAddress
          username
          userimage
          type
          __typename
        }
        createDate
        feedback
        __typename
      }
      status
      readByFaculty
      __typename
    }
  }
`;
export const getAssessment = /* GraphQL */ `
  query GetAssessment($classId: Int!, $lessonId: String!, $termId: Int) {
    getAssessment(classId: $classId, lessonId: $lessonId, termId: $termId) {
      id
      classId
      lessonId
      termId
      finished
      passed
      createDate
      lastUpdate
      progressMap {
        questionId
        userAnswerId
        correctAnswerId
        __typename
      }
      __typename
    }
  }
`;
export const getUserGiftSubscriptions = /* GraphQL */ `
  query GetUserGiftSubscriptions {
    getUserGiftSubscriptions {
      id
      classId
      libraryId
      createDate
      recipientName
      senderName
      claimed
      claimDate
      notificationTime
      emailAddress
      senderEmail
      classTitle
      classImage
      subscriberId
      classSubscriptionId
      invitationKey
      message
      __typename
    }
  }
`;
export const getAllVideoAssignmentSubmissions = /* GraphQL */ `
  query GetAllVideoAssignmentSubmissions($classId: Int!) {
    getAllVideoAssignmentSubmissions(classId: $classId) {
      id
      classId
      createDate
      assignmentId
      objectType
      status
      submittedVideoId
      statusHistory {
        event
        videoId
        createDate
        __typename
      }
      videos {
        id
        createDate
        duration
        failed
        clips {
          path
          thumbnail
          ordinal
          __typename
        }
        thumbnails
        analysis {
          recordingIssues
          recordingQuality
          sideBySideCoverage
          summary
          topics {
            startTime
            endTime
            title
            summary
            __typename
          }
          __typename
        }
        status
        __typename
      }
      userId
      roomId
      recordingStartedAt
      recordingStoppedAt
      submittedDate
      assignedInstructorId
      __typename
    }
  }
`;
export const getByUserIdAndVideoAssignmentId = /* GraphQL */ `
  query GetByUserIdAndVideoAssignmentId(
    $input: GetVideoSubmissionByUserAndAssignmentId!
  ) {
    getByUserIdAndVideoAssignmentId(input: $input) {
      id
      classId
      createDate
      assignmentId
      objectType
      status
      submittedVideoId
      statusHistory {
        event
        videoId
        createDate
        __typename
      }
      videos {
        id
        createDate
        duration
        failed
        clips {
          path
          thumbnail
          ordinal
          __typename
        }
        thumbnails
        analysis {
          recordingIssues
          recordingQuality
          sideBySideCoverage
          summary
          topics {
            startTime
            endTime
            title
            summary
            __typename
          }
          __typename
        }
        status
        __typename
      }
      userId
      roomId
      recordingStartedAt
      recordingStoppedAt
      submittedDate
      assignedInstructorId
      __typename
    }
  }
`;
export const getByClassIdAndVideoAssignmentId = /* GraphQL */ `
  query GetByClassIdAndVideoAssignmentId(
    $input: GetVideoSubmissionByClassAndAssignmentId!
  ) {
    getByClassIdAndVideoAssignmentId(input: $input) {
      videos {
        id
        createDate
        duration
        failed
        clips {
          path
          thumbnail
          ordinal
          __typename
        }
        thumbnails
        analysis {
          recordingIssues
          recordingQuality
          sideBySideCoverage
          summary
          topics {
            startTime
            endTime
            title
            summary
            __typename
          }
          __typename
        }
        status
        __typename
      }
      assignmentId
      objectType
      submittedVideoId
      status
      statusHistory {
        event
        videoId
        createDate
        __typename
      }
      classId
      gsi_pk
      createDate
      userId
      sk
      id
      pk
      user {
        email
        name
        __typename
      }
      instructor {
        email
        name
        __typename
      }
      submittedDate
      __typename
    }
  }
`;
export const getSendbirdUser = /* GraphQL */ `
  query GetSendbirdUser($input: GetSendbirdUser!) {
    getSendbirdUser(input: $input) {
      user_id
      nickname
      profile_url
      is_active
      __typename
    }
  }
`;
export const getSendbirdRoom = /* GraphQL */ `
  query GetSendbirdRoom($input: GetSendbirdRoom!) {
    getSendbirdRoom(input: $input) {
      created_by
      deleted_by
      state
      room_id
      room_type
      cloud_recordings {
        recording_id
        target_event_type
        room_id
        media_type
        status
        started_at
        __typename
      }
      __typename
    }
  }
`;
export const getVideoAssignmentByTermId = /* GraphQL */ `
  query GetVideoAssignmentByTermId($termId: Int!) {
    getVideoAssignmentByTermId(termId: $termId) {
      id
      title
      __typename
    }
  }
`;
export const getTermsByClassId = /* GraphQL */ `
  query GetTermsByClassId($classId: Int!) {
    getTermsByClassId(classId: $classId) {
      id
      title
      startDate
      signupCutOffDate
      __typename
    }
  }
`;
